const ByDate = '1101'
const Undefined = '1102'
const ByEvent = '1103'

export default {
    ByDate: ByDate,
    ByEvent: ByEvent,
    Undefined: Undefined,
}